
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startIncubadoraXID, startListadoEncubadora } from "../../../services";






export const useIncubadoraXID = (id) => {

    const incubadoraXIDQuery = useQuery({
        queryKey: ['incubadora-id', id], 
        queryFn: () => startIncubadoraXID(id),
    });

    return {
        incubadoraXIDQuery
    }
}





export const useEncubadoraQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const encubadoraListQuery = useQuery({
        queryKey: ['encubadora-list', { page, termino }], 
        queryFn: () => startListadoEncubadora({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }
    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        encubadoraListQuery,
    }
}
